import React, { useState } from "react";

type AfishaSearchBarProps = {
  loading?: boolean;
  autoFocus?: boolean;
  onSearch: (query: string) => void;
};

export const AfishaSearchBar = ({
  loading,
  autoFocus,
  onSearch,
}: AfishaSearchBarProps) => {
  const [query, setQuery] = useState("");

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const trimmed = query.trim();
    if (!trimmed || loading) return;
    onSearch(trimmed);
  };

  return (
    <form className="afisha__search" onSubmit={handleSubmit}>
      <input
        className="afisha__search-input"
        type="search"
        value={query}
        placeholder="Поиск: джаз, детское, бизнес…"
        aria-label="Поиск мероприятий"
        autoFocus={autoFocus}
        onChange={(event) => setQuery(event.target.value)}
      />
      <button
        className="afisha__search-btn afisha__search-btn--icon"
        type="submit"
        disabled={loading || !query.trim()}
        aria-label="Найти"
        title="Найти"
      >
        {loading ? "…" : <i className="bi bi-search" aria-hidden />}
      </button>
    </form>
  );
};
